import { LocationsPayload } from "../../components/filters/Locations/types";
import { SAMConfig } from "../../types/workspace";

export interface Competitor {
  id: string;
  name: string;
}

export interface UseLocationStateProps {
  samConfiguration: SAMConfig;
  onUpdate: (geography: SAMConfig["geography"]) => void;
}

export interface UseLocationStateReturn {
  includeLocations: LocationsPayload;
  excludeLocations: LocationsPayload;
  handleIncludeLocationsChange: (payload: LocationsPayload) => void;
  handleExcludeLocationsChange: (excludedCountryIds: string[]) => void;
  overrideWithIcpData: (countryIds: string[]) => void;
  mergeWithIcpData: (countryIds: string[]) => void;
}

export enum ConfigTab {
  MARKET_SIZING = "market-sizing",
  WHITESPACE = "whitespace",
  COMPETITORS = "competitors",
  SETTINGS = "settings",
}
